module.exports = "./app-dist/templates/header-mobile-distributor.controller.e29bfbe2f7ae300b6c4d9fc1ff5bb893.html";